import { app } from '../../app';
import { Controller } from './destructive-operation.controller';

app.component('destructiveOperation', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./destructive-operation.html'),
});



// WEBPACK FOOTER //
// ./src/portal/modals/destructive-operation/destructive-operation.component.js